<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/']">
                  <i class=" fas fa-home"></i>
                </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/external-contact']"> External Contact </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/external-payment-info']"> Payment Information </a>
              </li>

            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
<div class=" container-fluid mt--6">
  <form [formGroup]="paymentInfoForm" (ngSubmit)="onSubmit()">
    <!-- Main Bank -->
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-9 col-lg-9 col-sm-12">
            Bank Account Information
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                Bank Name
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('bankName')?.invalid
                              && paymentInfoForm.get('bankName')?.touched }" class="form-control"
                       formControlName="bankName"
                       id="bankNameInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('bankName')?.invalid     && paymentInfoForm.get('bankName')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('bankName')?.hasError('required')">
                    Bank Name is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('bankName')?.hasError('maxlength')">
                    Bank Name cannot
                    exceed {{ paymentInfoForm.get('bankName')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('bankName')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('bankName')?.errors?.['latinCharacters'].message }}
                  </div>

                </div>
              </div>

            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                Bank Address
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('bankAddress')?.invalid
                              && paymentInfoForm.get('bankAddress')?.touched }"
                       class="form-control"
                       formControlName="bankAddress"
                       id="bankAddressInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('bankAddress')?.invalid     && paymentInfoForm.get('bankAddress')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('bankAddress')?.hasError('required')">
                    Bank Address is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('bankAddress')?.hasError('maxlength')">
                    Bank Address cannot
                    exceed {{ paymentInfoForm.get('bankAddress')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('bankAddress')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('bankAddress')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                Account Holder Name
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('accountHolderName')?.invalid
                             && paymentInfoForm.get('accountHolderName')?.touched }" class="form-control"
                       formControlName="accountHolderName"
                       id="accountHolderNameInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('accountHolderName')?.invalid     && paymentInfoForm.get('accountHolderName')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('accountHolderName')?.hasError('required')">
                    Account Holder Name is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('accountHolderName')?.hasError('maxlength')">
                    Account Holder Name cannot
                    exceed {{ paymentInfoForm.get('accountHolderName')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('accountHolderName')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('accountHolderName')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                Account Holder Address
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('accountHolderAddress')?.invalid
                             && paymentInfoForm.get('accountHolderAddress')?.touched }"
                       class="form-control"
                       formControlName="accountHolderAddress"
                       id="accountHolderAddressInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('accountHolderAddress')?.invalid     && paymentInfoForm.get('accountHolderAddress')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('accountHolderAddress')?.hasError('required')">
                    Account Holder Address is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('accountHolderAddress')?.hasError('maxlength')">
                    Account Holder Address cannot
                    exceed {{ paymentInfoForm.get('accountHolderAddress')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('accountHolderAddress')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('accountHolderAddress')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                IBAN
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('iban')?.invalid
                               && paymentInfoForm.get('iban')?.touched }" class="form-control"
                       formControlName="iban"
                       id="ibanInput" type="text" (change)="formIBANChange()">
                <div
                  *ngIf="paymentInfoForm.get('iban')?.invalid && paymentInfoForm.get('iban')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('iban')?.hasError('required')">
                    IBAN Address is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('iban')?.hasError('maxlength')">
                    IBAN cannot
                    exceed {{ paymentInfoForm.get('iban')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('iban')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('iban')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                ABAN/BIC/SWIFT
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('swift')?.invalid
                               && paymentInfoForm.get('swift')?.touched }" class="form-control"
                       formControlName="swift"
                       id="swiftInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('swift')?.invalid     && paymentInfoForm.get('swift')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('swift')?.hasError('required')">
                    ABAN/BIC/SWIFT is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('swift')?.hasError('maxlength')">
                    ABAN/BIC/SWIFT cannot
                    exceed {{ paymentInfoForm.get('swift')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('swift')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('swift')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                ABA
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('aba')?.invalid
                               && paymentInfoForm.get('aba')?.touched }" class="form-control"
                       formControlName="aba"
                       id="abaInput" type="text" (change)="formABAChange()">
                <div
                  *ngIf="paymentInfoForm.get('aba')?.invalid && paymentInfoForm.get('aba')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('aba')?.hasError('required')">
                    ABA is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('aba')?.hasError('maxlength')">
                    ABA cannot
                    exceed {{ paymentInfoForm.get('aba')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('aba')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('aba')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                Currency
              </label>
              <div class="col-md-9">
                <select [ngClass]="{ 'is-invalid': paymentInfoForm.get('currencyId')?.invalid
                               && paymentInfoForm.get('currencyId')?.touched }"
                        class="form-control"
                        formControlName="currencyId" id="currencyDdl" name="cars">
                  <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>

                </select>
                <div
                  *ngIf="paymentInfoForm.get('currencyId')?.invalid     && paymentInfoForm.get('currencyId')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('currencyId')?.hasError('required')">
                    Currency is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('currencyId')?.hasError('maxlength')">
                    Currency cannot
                    exceed {{ paymentInfoForm.get('currencyId')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('currencyId')?.hasError('pattern')">
                    Currency must use Latin characters only.
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <!-- Corresponding -->
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-9 col-lg-9 col-sm-12">
            Corresponding Bank
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                Bank Name
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('correspondBankName')?.invalid
                              && paymentInfoForm.get('correspondBankName')?.touched }" class="form-control"
                       formControlName="correspondBankName"
                       id="correspondBankNameInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('correspondBankName')?.invalid     && paymentInfoForm.get('correspondBankName')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('correspondBankName')?.hasError('required')">
                    Bank Name is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondBankName')?.hasError('maxlength')">
                    Bank Name cannot
                    exceed {{ paymentInfoForm.get('correspondBankName')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondBankName')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('correspondBankName')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                Bank Address
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('correspondBankAddress')?.invalid
                              && paymentInfoForm.get('correspondBankAddress')?.touched }"
                       class="form-control"
                       formControlName="correspondBankAddress"
                       id="AHAddressInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('correspondBankAddress')?.invalid     && paymentInfoForm.get('correspondBankAddress')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('correspondBankAddress')?.hasError('required')">
                    Address is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondBankAddress')?.hasError('maxlength')">
                    Address cannot
                    exceed {{ paymentInfoForm.get('correspondBankAddress')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondBankAddress')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('correspondBankAddress')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                IBAN
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('correspondIBAN')?.invalid
                               && paymentInfoForm.get('correspondIBAN')?.touched }" class="form-control"
                       formControlName="correspondIBAN"
                       id="correspondIBANInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('correspondIBAN')?.invalid     && paymentInfoForm.get('correspondIBAN')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('correspondIBAN')?.hasError('required')">
                    IBAN Address is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondIBAN')?.hasError('maxlength')">
                    IBAN cannot
                    exceed {{ paymentInfoForm.get('correspondIBAN')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondIBAN')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('correspondIBAN')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                ABAN/BIC/SWIFT
              </label>
              <div class="col-md-9">
                <input [ngClass]="{ 'is-invalid': paymentInfoForm.get('correspondSWIFT')?.invalid
                               && paymentInfoForm.get('correspondSWIFT')?.touched }" class="form-control"
                       formControlName="correspondSWIFT"
                       id="correspondSWIFTInput" type="text">
                <div
                  *ngIf="paymentInfoForm.get('correspondSWIFT')?.invalid     && paymentInfoForm.get('correspondSWIFT')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('correspondSWIFT')?.hasError('required')">
                    ABAN/BIC/SWIFT is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondSWIFT')?.hasError('maxlength')">
                    ABAN/BIC/SWIFT cannot
                    exceed {{ paymentInfoForm.get('correspondSWIFT')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondSWIFT')?.hasError('latinCharacters')">
                    {{ paymentInfoForm.get('correspondSWIFT')?.errors?.['latinCharacters'].message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-12">
            <div class="form-group row">
              <label class="col-md-3 col-form-label form-control-label">
                Currency
              </label>
              <div class="col-md-9">
                <select [ngClass]="{ 'is-invalid': paymentInfoForm.get('correspondCurrencyId')?.invalid
                               && paymentInfoForm.get('correspondCurrencyId')?.touched }"
                        class="form-control"
                        formControlName="correspondCurrencyId" >
                  <option [ngValue]="null">Select Currency</option>
                  <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>

                </select>
                <div
                  *ngIf="paymentInfoForm.get('correspondCurrencyId')?.invalid     && paymentInfoForm.get('correspondCurrencyId')?.touched"
                  class="invalid-feedback">
                  <div *ngIf="paymentInfoForm.get('correspondCurrencyId')?.hasError('required')">
                    Currency is required.
                  </div>
                  <div *ngIf="paymentInfoForm.get('correspondCurrencyId')?.hasError('maxlength')">
                    Currency cannot
                    exceed {{ paymentInfoForm.get('correspondCurrencyId')?.errors?.['maxlength'].requiredLength }}
                    characters.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <button class="btn btn-primary" type="submit">Submit</button>
        <button [routerLink]="['/external-contact']" class="btn btn-secondary" type="button">Back</button>
      </div>
    </div>
  </form>



</div>

<ngx-spinner
  bdColor="rgba(0,0,0,0.5)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
